import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import MainPage from './components/MainPage';
import Lessons from './components/Lessons';
import Task from './components/Task';
import Summary from './components/Summary';
import HowToUse from './components/HowToUse';
import Login from './components/Login';
import Cookies from 'js-cookie'; // Install js-cookie library if not already installed

function App() {
  const [sections, setSections] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if authToken exists in localStorage
  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    setIsAuthenticated(!!authToken); // Set authentication status based on token presence
  }, []);

  // Fetch sections
  useEffect(() => {
    if (sections.length === 0) {
      fetch('https://quiz.interaktywneseminaria.pl/api/sections')
        .then(response => response.json())
        .then(data => setSections(data))
        .catch(error => console.error('Error fetching sections:', error));
    }
  }, [sections.length]);

  // Update question state
  const updateQuestionState = (sectionId, lessonId, taskId, introductionsId, questionIndex) => {
    const sectionIndex = parseInt(sectionId, 10) - 1;
    const lessonIndex = parseInt(lessonId, 10) - 1;
    const taskIndex = parseInt(taskId, 10) - 1;
    const introductionIndex = parseInt(introductionsId, 10) - 1;

    const updatedSections = [...sections];
    const question = updatedSections[sectionIndex].lessons[lessonIndex].tasks[taskIndex].introductions[introductionIndex].questions[questionIndex];
    question.checked = !question.checked;

    setSections(updatedSections);
  };

  // Reset lesson state
  const resetLessonState = (sectionId, lessonId) => {
    const sectionIndex = parseInt(sectionId, 10) - 1;
    const lessonIndex = parseInt(lessonId, 10) - 1;

    const updatedSections = [...sections];
    const lesson = updatedSections[sectionIndex].lessons[lessonIndex];

    lesson.tasks.forEach(task => {
      task.introductions.forEach(introduction => {
        introduction.questions.forEach(question => {
          question.checked = false;
        });
      });
    });

    setSections(updatedSections);
  };

  // Component to handle /pharmapass/authorize
  const PharmapassAuthorize = () => {
    const navigate = useNavigate();

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');

      if (token) {
        // Set token in cookies and localStorage
        Cookies.set('authToken', token, { expires: 7 }); // Expires in 7 days
        localStorage.setItem('authToken', token);
        setIsAuthenticated(true);
      }

      // Redirect to the home page after setting the token
      navigate('/');
    }, [navigate]);

    return null; // No UI needed for this route
  };

  const handleLogout = () => {
    // Remove token from localStorage and cookies
    localStorage.removeItem('authToken');
    Cookies.remove('authToken');
    setIsAuthenticated(false);

    // Redirect to the logout URL
    window.location.href = 'https://interaktywneseminaria.pl/pharmapass/logout';
  };

  return (
    <Router>
      <div className="App">
        {isAuthenticated && (
          <button
            className="btn btn-danger"
            style={{ position: 'absolute', top: '10px', right: '10px' }}
            onClick={handleLogout}
          >
            Wyloguj się
          </button>
        )}
        <Routes>
          <>
            {/* Pharmapass authorize route */}
            <Route path="/pharmapass/authorize" element={<PharmapassAuthorize />} />

            {/* Protected routes */}
            {isAuthenticated ? (
              <>
                <Route path="/" element={<MainPage sections={sections} />} />
                <Route path="/how-to-use" element={<HowToUse />} />
                <Route path="/sections/:sectionId/lessons" element={<Lessons sections={sections} />} />
                <Route path="/sections/:sectionId/lessons/:lessonId/" element={<Task sections={sections} updateQuestionState={updateQuestionState} />} />
                <Route path="/sections/:sectionId/lessons/:lessonId/tasks/:taskId/introductions/:introductionsId" element={<Task sections={sections} updateQuestionState={updateQuestionState} />} />
                <Route path="/sections/:sectionId/summary" element={<Summary sections={sections} resetLessonState={resetLessonState} />} />
              </>
            ) : (
              <Route path="*" element={<Login />} />
            )}
          </>
        </Routes>
      </div>
    </Router>
  );
}

export default App;